import { intakeConstants as constants } from '../_constants/intake.constants';

export const initialState = {
  isLoading: false,
  collection: []
}

export function intake(state = initialState, action) {
  if (action.type === constants.INTAKE_SEARCH_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      collection: action.collection
    }
  }

  if (action.type === constants.INTAKE_SEARCH_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  return state;
}
